import React from "react";
import {useArticleForm} from "../../hooks/use-article-form.hook";
import AppButton from "@common/components/app-button";
import {XMarkIcon} from "@heroicons/react/20/solid";
import {convertLexicalJsonToHtml} from "../../helpers/lexical-to-html";
import {stripHtmlToText} from "../../helpers/strip-html-to-text";

interface SelectedRelatedArticleTagProps {
    title: string;
    id: string;
}

const SelectedRelatedArticleTag = (props: SelectedRelatedArticleTagProps) => {
    const {title, id} = props;
    const {form, updateStepData} = useArticleForm();

    const handleClick = () => {
        const selectedArticles = form.getValues("relatedArticles") ?? [];
        const updatedArticles = selectedArticles.filter(related => related.id !== id) ?? [];
        form.setValue('relatedArticles', updatedArticles);
        updateStepData('related' as any, {relatedArticles: form.getValues('relatedArticles')});
    };

    return (
        <div className="mr-2 mb-2 inline-block">
            <AppButton
                className="cursor-auto !w-fit h-[32px] !p-0 !pl-3 bg-surface-level-1 hover:bg-on-surface/5 border border-outline rounded-lg text-sm font-semibold"
            >
                <div className="flex items-center">
                    <span className="flex !h-fit max-h-fit">
                        {stripHtmlToText(convertLexicalJsonToHtml(title))}
                    </span>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick();
                        }}
                        className="w-fit h-fit cursor-pointer hover:bg-on-surface/10 rounded-2xl p-1">
                        <XMarkIcon className="w-6 h-6 min-w-6"/>
                    </div>
                </div>
            </AppButton>
        </div>
    )
}

export default SelectedRelatedArticleTag
